import React, { createContext, useContext, useState } from 'react';

interface GenUIContextType {
  isOpen: boolean;
  setIsOpen: (open: boolean) => void;
  toggleGenUI: () => void;
}

const GenUIContext = createContext<GenUIContextType | undefined>(undefined);

export const GenUIProvider: React.FC<{ children: React.ReactNode }> = ({ children }) => {
  const [isOpen, setIsOpen] = useState(false);
  const toggleGenUI = () => setIsOpen((prev) => !prev);

  return (
    <GenUIContext.Provider value={{ isOpen, setIsOpen, toggleGenUI }}>
      {children}
    </GenUIContext.Provider>
  );
};

export const useGenUI = () => {
  const ctx = useContext(GenUIContext);
  if (!ctx) throw new Error('useGenUI must be used within GenUIProvider');
  return ctx;
};
